import { api } from '@/api';
import type { DeviceRestrictions, DeviceRestrictionsResponse } from '../types';
import { formatPin } from './formatPin';

// fetchDeviceRestrictions loads theft protection, work schedule and override key of a device,
// restoring the leading zeros both PINs lost when the backend serialised them as numbers.
// Requires user level 1 on the backend; a 403 is a plain no-access answer.
// The response carries plaintext PINs, so it must never be logged.
export async function fetchDeviceRestrictions(deviceId: string): Promise<DeviceRestrictions> {
  const response = await api.get<DeviceRestrictionsResponse>(`/v1/devices/${deviceId}/restrictions`);
  return {
    ...response,
    theftProtection: { ...response.theftProtection, unlockPin: formatPin(response.theftProtection.unlockPin) },
    overrideKey: formatPin(response.overrideKey),
  };
}
